import React from 'react';
import { Quote, ShieldCheck } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-20 bg-brand-light" data-id="element-588">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-589">
        <div className="text-center mb-16" data-id="element-590">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-591">
            Trusted by Professionals
          </h2>
          <p className="text-xl text-gray-600" data-id="element-592">
            Real feedback from contractors in the field.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-593">
          <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm" data-id="element-594">
            <Quote className="h-10 w-10 text-brand-yellow mb-4" data-id="element-595" />
            <p className="text-gray-700 text-lg mb-6 leading-relaxed" data-id="element-596">
              "Made my attic work faster and safer. No more hauling chemicals up
              ladders."
            </p>
            <div className="flex items-center" data-id="element-597">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-full flex items-center justify-center mr-4" data-id="element-598">
                <span className="text-brand-dark font-bold text-lg" data-id="element-599">DC</span>
              </div>
              <div data-id="element-600">
                <div className="font-bold text-brand-dark" data-id="element-601">Dustin C.</div>
                <div className="text-gray-500 text-sm" data-id="element-602">Contractor</div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm" data-id="element-603">
            <Quote className="h-10 w-10 text-brand-yellow mb-4" data-id="element-604" />
            <p className="text-gray-700 text-lg mb-6 leading-relaxed" data-id="element-605">
              "This system just works. Plug it in and spray."
            </p>
            <div className="flex items-center" data-id="element-606">
              <div className="w-12 h-12 bg-brand-yellow/10 rounded-full flex items-center justify-center mr-4" data-id="element-607">
                <ShieldCheck className="h-6 w-6 text-brand-yellow" data-id="element-608" />
              </div>
              <div data-id="element-609">
                <div className="font-bold text-brand-dark" data-id="element-610">
                  Restoration Contractor
                </div>
                <div className="text-gray-500 text-sm" data-id="element-611">Verified Buyer</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}